import React from "react";
import { CheckCircle2 } from "lucide-react";
import { smoothScrollHash } from "../lib/smoothScroll";

const LEARN = [
  {
    title: "PVT LTD vs LLP vs OPC — which fits you?",
    body:
      "PVT LTD suits fundraise-ready Startups. LLP is cheaper to run for professional firms. OPC lets a solo founder stay compliant. We help you pick based on tax, compliance cost, and investor readiness.",
  },
  {
    title: "GST registration — mandatory or optional?",
    body:
      "Services > ₹20L turnover, goods > ₹40L, or any inter-state supply usually triggers GST. E-commerce sellers need it day one. We check thresholds and register within 3–5 working days.",
  },
  {
    title: "Current account: which bank & why",
    body:
      "HDFC for founder-friendly onboarding, ICICI for digital-first ops, KOTAK for Startup-focused relationship managers. We match banks based on your volumes, zero-balance needs and industry.",
  },
  {
    title: "Choosing a payment gateway",
    body:
      "Razorpay is developer-friendly with the widest stack. Cashfree has lower MDR at scale. PhonePe wins on UPI conversions. We negotiate MDR and speed up KYC for faster go-live.",
  },
];

const PERKS = [
  "One accountable team, zero vendor juggling",
  "Transparent pricing — no hidden government fees",
  "Trusted by 1,200+ Indian founders",
];

export default function Education() {
  return (
    <section id="why" className="border-b border-black/10 bg-white" data-testid="education-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#EAB308]">
              [ 03 ] Founder&apos;s Guide
            </p>
            <h2 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mt-4 max-w-xl">
              Learn before you launch.
            </h2>
            <p className="mt-5 text-black/70 max-w-xl">
              The decisions you make in month one shape your next five years.
              Here&apos;s a quick decision guide for the most common founder
              questions.
            </p>

            <div className="mt-10 space-y-5">
              {LEARN.map((l, i) => (
                <article
                  key={l.title}
                  data-testid={`education-item-${i}`}
                  className="border border-black/80 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:neo-shadow-sm"
                >
                  <h3 className="font-heading font-bold text-xl">{l.title}</h3>
                  <p className="mt-2 text-sm text-black/70 leading-relaxed">
                    {l.body}
                  </p>
                </article>
              ))}
            </div>
          </div>

          <aside className="md:col-span-5">
            <div className="md:sticky md:top-28">
              <div className="border-2 border-black bg-white text-black p-8">
                <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#EAB308]">
                  Why ZOZO Venture
                </p>
                <h3 className="font-heading font-black text-3xl sm:text-4xl mt-3 leading-tight">
                  Your co-founder for everything.
                </h3>
                <ul className="mt-6 space-y-3">
                  {PERKS.map((p) => (
                    <li key={p} className="flex items-start gap-3">
                      <CheckCircle2 size={18} className="mt-0.5 text-[#EAB308] shrink-0" />
                      <span className="text-sm text-black/80">{p}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#lead-form"
                  onClick={smoothScrollHash}
                  data-testid="education-cta"
                  className="mt-7 inline-flex w-full justify-center items-center gap-2 bg-[#EAB308] text-white px-5 py-3 font-semibold hover:bg-black hover:text-white transition-colors"
                >
                  Get expert advice →
                </a>
              </div>

              <div className="mt-5 relative" style={{ aspectRatio: "4 / 3" }}>
                <img
                  src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200"
                  alt="Indian founders consulting"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-black/10" />
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
